import React, { useState, useEffect, useRef } from 'react';
import { Leaf, Sprout } from 'lucide-react';

interface CarouselItem {
  id: number;
  imageUrl: string;
  name: string;
  description: string;
}

const carouselData: CarouselItem[] = [
  { 
    id: 1, 
    imageUrl: "https://images.unsplash.com/photo-1655432866668-fef51361d3d7?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", 
    name: "El Savado Field", 
    description: "Vibrant fields of sugar cane." 
  },
  { 
    id: 2, 
    imageUrl: "https://images.unsplash.com/photo-1578551398707-40b80f341b32?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", 
    name: "The Philipine Suagr Mines", 
    description: "Vibrant fields of sugar cane." 
  },
  { 
    id: 3, 
    imageUrl: "https://plus.unsplash.com/premium_photo-1718146019864-3b40d37306e7?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", 
    name: "The Tour", 
    description: "Tours of the sugar cane fields." 
  },
  { 
    id: 4, 
    imageUrl: "https://images.unsplash.com/photo-1566677052902-867225f7f9fd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHN1Z2FyJTIwZmFybWVyfGVufDB8MXwwfHx8MA%3D%3D", 
    name: "DeSusse", 
    description: "Martin DeSusse' neo-modern photo session in the fields of eSwatini." 
  },
  { 
    id: 5, 
    imageUrl: "https://images.unsplash.com/photo-1655432866668-fef51361d3d7?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", 
    name: "El Savado Field", 
    description: "Vibrant fields of sugar cane." 
  },
];

const GalleryCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const infoBox = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (!isHovered) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === carouselData.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [isHovered]);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const getImageStyle = (index: number) => {
    const isCenter = index % 2 === 0;
    return {
      margin: '0 2rem', // Spacing between images
      transform: isCenter ? 'scale(1.1) translateY(-10px)' : 'scale(1)',
      boxShadow: isCenter ? '0 10px 20px rgba(0, 0, 0, 0.2)' : '0 5px 10px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.5s ease, box-shadow 0.5s ease',
    };
  };

  return (
    <div
      className="relative w-full p-4"
    >
      <div className={`flex overflow-hidden`}>
        <div
          className="flex transition-transform duration-1000 ease-in-out py-15"
          style={{
            width: `${carouselData.length * 25}vw`,
            transform: `translateX(-${currentIndex * 10}vw)`,
          }}
        >
          {carouselData.map((item, index) => (
            <div
              key={item.id}
              className="relative group carousel-image action group-hover:scale-110 transition duration-2000 ease-in-out"
              style={getImageStyle(index)}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={item.imageUrl}
                alt={item.name}
                className="w-full h-full object-cover rounded-lg group-hover:scale-110 transition duration-2000 ease-in-out"
              />
              <div
                ref={infoBox}
                className="absolute bottom-15 left w-[80%] bg-yellow-200 text-black py-3 px-5 rounded-r-sm opacity-0 group-hover:opacity-100 transition-opacity duration-2000 z-[100]"
              >
                <div className="flex gap-2">
                  <Sprout className="!w-6 !h-6 text-lime-500" />
                  <div className="flex-col gap-2">
                    <h3 className="font-bold text-sm">{item.name}</h3>
                    <p className="text-sm">{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryCarousel;